// extracted by mini-css-extract-plugin
export var arrows = "_55-5";
export var decrementer = "_55-9";
export var disabled = "_55-3";
export var error = "_55-1";
export var hiddenText = "_55-a";
export var incrementer = "_55-8";
export var input = "_55-7";
export var inputWrapper = "_55-0";
export var readonly = "_55-2";
export var regular = "_55-6";
export var small = "_55-4";